import React from 'react'
import ResponsiveContainer from "./SemanticNavbar/SemanticNavbar";
import ResponsiveContainerLoggedIn from "./SemanticNavbar/SemanticNavbarLoggedIn";
import Firebase from '../services/firebase'



/**
 * Despite the name, renders the entire layout within a Desktop or Mobile container
 */
class  Sidebar extends React.Component {
  state = {
    responsiveContainer: <ResponsiveContainer/>,
  };
  componentDidMount() {
     this.getCorrectNavbar.bind(this);
     this.getCorrectNavbar();
  }

  /** Needs to be async. Don't know why. */
  getCorrectNavbar = async () => {
    Firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({responsiveContainer: <ResponsiveContainerLoggedIn/>});
      }
    });
  };

  render() {
      return (
        this.state.responsiveContainer
      );
  }
}

export default Sidebar;
